import { apiFetch, apiRequest } from './client';
export async function getLesions(patientId, clinicId) {
    return apiFetch(`/patients/${encodeURIComponent(patientId)}/lesions?clinicId=${encodeURIComponent(clinicId)}`);
}
export async function getLesionMeasurements(lesionId) {
    return apiFetch(`/lesions/${encodeURIComponent(lesionId)}/measurements`);
}
export async function createLesion(patientId, payload) {
    return apiRequest('POST', `/patients/${encodeURIComponent(patientId)}/lesions`, payload);
}
export async function addMeasurement(lesionId, payload) {
    return apiRequest('POST', `/lesions/${encodeURIComponent(lesionId)}/measurements`, payload);
}
export async function deleteLesion(lesionId) {
    return apiRequest('DELETE', `/lesions/${encodeURIComponent(lesionId)}`);
}
export async function deleteMeasurement(measurementId) {
    return apiRequest('DELETE', `/measurements/${encodeURIComponent(measurementId)}`);
}
